"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var store_1 = require("../store/store");
var legacy_1 = require("satcheljs/lib/legacy");
exports.default = legacy_1.select({
    optionState: function () { return store_1.default; },
})(legacy_1.action('selectFormattingOption')(function selectFormattingOption(formatOption, isSet, state) {
    var optionState = state.optionState;
    optionState[formatOption] = isSet;
}));
//# sourceMappingURL=selectFormattingOption.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/options/config/mail/owa-message-format-option/lib/actions/selectFormattingOption.js
// module id = 5154
// module chunks = 2